import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useIntercom } from "@/hooks/useIntercom";
import { INTERCOM_ARTICLES } from "@/intercom";
import { Trans } from "@lingui/react/macro";
import { TriangleAlertIcon } from "lucide-react";

export default function DeprecatedWidgetWarning() {
  const { showArticle } = useIntercom();

  // Handlers
  const handleClick = (event: React.MouseEvent) => {
    if (!showArticle) return;
    event.preventDefault();
    showArticle(INTERCOM_ARTICLES.TOPICS_DEPRECATION);
  };

  return (
    <Tooltip>
      <TooltipTrigger
        onClick={handleClick}
        className="text-orange-400 hover:text-orange-500 print:hidden"
        data-testid="deprecated-widget-warning"
      >
        <TriangleAlertIcon className="size-5" />
        <span className="sr-only">
          <Trans>Läs mer om den här grafen</Trans>
        </span>
      </TooltipTrigger>

      <TooltipContent>
        <Trans>
          Den här grafen kommer snart att tas bort. Klicka för att läsa mer.
        </Trans>
      </TooltipContent>
    </Tooltip>
  );
}
